import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-62961c68"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sc-footer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sc-offset flex-vertical sc-footer-inner"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "footer-label"
}, "Рауза-АДЕ. Центр жалоб и предложений. 2022")], -1));
const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
}